import Environment from '@/generic/models/Environment';
import AppHelper from '../helpers/AppHelper';

export default class EnvService {
    public static getEnvironment(): Environment {
        const browserWindow: any = window || {};
        const env = browserWindow.__env || {};
        const apex = AppHelper.getApexFromUrl();

        return new Environment(env, apex);
    }
}
